import { useTranslation } from 'react-i18next';
import Button from '../../../button/button';

interface ClearFilterButtonProps {
  onClick: () => void;
}

const ClearFilterButton = ({ onClick }: ClearFilterButtonProps) => {
  const { t } = useTranslation();

  return (
    <Button type="default" fullWidth={false} onClick={onClick}>
      {t('clear', 'Clear')}
    </Button>
  );
};

export default ClearFilterButton;
